import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-white/80 backdrop-blur-md'
    }`}>
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/f2824006b8e214af3bf77ca05a5a0829/17d80d203e78d22dd9a885a8c832a39a.png" 
              alt="PULSAR FC"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            <Link 
              to="/" 
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/') ? 'text-orange-500' : 'text-slate-700 hover:text-orange-500'
              }`}
            >
              Accueil
            </Link>
            <Link 
              to="/qui-sommes-nous" 
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/qui-sommes-nous') ? 'text-orange-500' : 'text-slate-700 hover:text-orange-500'
              }`}
            >
              Qui sommes-nous
            </Link>
            <Link 
              to="/nos-actions" 
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/nos-actions') ? 'text-orange-500' : 'text-slate-700 hover:text-orange-500'
              }`}
            >
              Nos actions
            </Link>
            <Link 
              to="/publics-accompagnes" 
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/publics-accompagnes') ? 'text-orange-500' : 'text-slate-700 hover:text-orange-500'
              }`}
            >
              Publics accompagnés
            </Link>
            <Link 
              to="/partenariats-impact" 
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/partenariats-impact') ? 'text-orange-500' : 'text-slate-700 hover:text-orange-500'
              }`}
            >
              Partenariats
            </Link>
            <Link 
              to="/contact" 
              className="px-6 py-2.5 bg-orange-500 text-white rounded-full text-sm font-semibold hover:bg-orange-600 transition-all duration-300 shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
            >
              Contact
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-slate-700 hover:text-orange-500 transition-colors cursor-pointer"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-6 border-t border-slate-200">
            <div className="flex flex-col gap-4">
              <Link 
                to="/" 
                onClick={() => setIsMobileMenuOpen(false)}
                className={`text-sm font-semibold transition-colors cursor-pointer ${
                  isActive('/') ? 'text-orange-500' : 'text-slate-700 hover:text-orange-500'
                }`}
              >
                Accueil
              </Link>
              <Link 
                to="/qui-sommes-nous" 
                onClick={() => setIsMobileMenuOpen(false)}
                className={`text-sm font-semibold transition-colors cursor-pointer ${
                  isActive('/qui-sommes-nous') ? 'text-orange-500' : 'text-slate-700 hover:text-orange-500'
                }`}
              >
                Qui sommes-nous
              </Link>
              <Link 
                to="/nos-actions" 
                onClick={() => setIsMobileMenuOpen(false)}
                className={`text-sm font-semibold transition-colors cursor-pointer ${
                  isActive('/nos-actions') ? 'text-orange-500' : 'text-slate-700 hover:text-orange-500'
                }`}
              >
                Nos actions
              </Link>
              <Link 
                to="/publics-accompagnes" 
                onClick={() => setIsMobileMenuOpen(false)}
                className={`text-sm font-semibold transition-colors cursor-pointer ${
                  isActive('/publics-accompagnes') ? 'text-orange-500' : 'text-slate-700 hover:text-orange-500'
                }`}
              >
                Publics accompagnés
              </Link>
              <Link 
                to="/partenariats-impact" 
                onClick={() => setIsMobileMenuOpen(false)}
                className={`text-sm font-semibold transition-colors cursor-pointer ${
                  isActive('/partenariats-impact') ? 'text-orange-500' : 'text-slate-700 hover:text-orange-500'
                }`}
              >
                Partenariats
              </Link>
              <Link 
                to="/contact" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-6 py-2.5 bg-orange-500 text-white rounded-full text-sm font-semibold hover:bg-orange-600 transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
